<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Add from "./add";
import Show from "./show";
import { mapGetters } from 'vuex';
import { VueContentLoading } from 'vue-content-loading';

export default {
  page: {
    title: "ماذا نقدم",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader, Add, Show, VueContentLoading },
  data() {
    return {
      title: "ماذا نقدم",
      items: [
        {
          text: "الرئيسية",
          href: "/",
        },
        {
          text: "ماذا نقدم",
          active: true,
        },
      ],

      canAdd: false,
      canShow: false,
      loadingContent: true,
    }
  },
  computed:{
    ...mapGetters('auth', ['getUser'])
  },
  created(){
    this.canAdd  = this.getUser.hasPermission('add_blog');
    this.canShow = this.getUser.hasAnyPermission(['show_blog','edit_blog','delete_blog']);
  },
  mounted() {
    setTimeout(() => {
      this.loadingContent = false;
    }, 1000);
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">

      <div class="col-md-12">
        <div class="card">

          <div v-if="!loadingContent" class="card-body">

            <b-tabs v-if="this.canAdd && canShow"  justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
              <b-tab active>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="bx bx-plus-circle"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">اضافة</span>
                </template>

                <Add />

              </b-tab>

              <b-tab>
                <template v-slot:title>
                  <span class="d-inline-block d-sm-none">
                    <i class="bx bx-play-circle"></i>
                  </span>
                  <span class="d-none d-sm-inline-block">عرض</span>
                </template>

                <Show />
                
              </b-tab>
            </b-tabs>

            <Show v-else-if="canShow" />
            <Add v-else-if="canAdd" />

          </div>

          <!-- loading content -->
          <div v-else>
            <vue-content-loading :rtl="true" :width="400" :height="270">
              <rect x="85" y="10" rx="1" ry="1" width="30" height="2" />
              <rect x="275" y="10" rx="1" ry="1" width="30" height="2" />
              <rect x="6" y="15" rx="1" ry="1" width="194" height="2" />
              <rect x="200" y="16" rx="1" ry="1" width="194" height="1" />
              
              <rect x="10" y="24" rx="1" ry="1" width="50" height="2" />
              <rect x="10" y="28" rx="1" ry="1" width="4" height="4" />
              <rect x="16" y="30" rx="1" ry="1" width="10" height="1" />
              <rect x="30" y="28" rx="1" ry="1" width="4" height="4" />
              <rect x="36" y="30" rx="1" ry="1" width="10" height="1" />
              <rect x="50" y="28" rx="1" ry="1" width="4" height="4" />
              <rect x="56" y="30" rx="1" ry="1" width="10" height="1" />

              <rect x="10" y="38" rx="1" ry="1" width="50" height="2" />
              <rect x="10" y="42" rx="1" ry="1" width="380" height="10" />
              <rect x="10" y="57" rx="1" ry="1" width="50" height="2" />
              <rect x="10" y="61" rx="1" ry="1" width="380" height="10" />
              <rect x="10" y="76" rx="1" ry="1" width="50" height="2" />
              <rect x="10" y="80" rx="1" ry="1" width="380" height="10" />
              <rect x="10" y="95" rx="1" ry="1" width="50" height="2" />
              <rect x="10" y="99" rx="1" ry="1" width="360" height="10" />
              <rect x="371" y="99" rx="1" ry="1" width="19" height="10" />

              <rect x="10" y="114" rx="1" ry="1" width="50" height="2" />
              <rect x="10" y="118" rx="1" ry="1" width="380" height="35" />
              <rect x="10" y="159" rx="1" ry="1" width="50" height="2" />
              <rect x="10" y="163" rx="1" ry="1" width="380" height="35" />
              <rect x="10" y="204" rx="1" ry="1" width="50" height="2" />
              <rect x="10" y="208" rx="1" ry="1" width="380" height="35" />
              <rect x="10" y="251" rx="1" ry="1" width="380" height="1" />
              <rect x="10" y="256" rx="1" ry="1" width="20" height="10" />
              <rect x="32" y="256" rx="1" ry="1" width="20" height="10" />
            </vue-content-loading>
          </div>

        </div>
      </div>
                    
    </div>
    
  </Layout>
</template>